// 常见问题
export default [{
    path: '/faq/list',
    name: 'faqList',
    component: () => import('@/views/faq/list')
}, {
    path: '/faq/search',
    name: 'faqSearch',
    component: () => import('@/views/faq/search')
}, {
    path: '/faq/detail/:id',
    name: 'faqDetail',
    component: () => import('@/views/faq/detail')
}]



// WEBPACK FOOTER //
// ./src/router/faq.js